import { render, staticRenderFns } from "./ComputacionFqa.vue?vue&type=template&id=70582218&scoped=true"
import script from "./ComputacionFqa.vue?vue&type=script&lang=js"
export * from "./ComputacionFqa.vue?vue&type=script&lang=js"
import style0 from "./ComputacionFqa.vue?vue&type=style&index=0&id=70582218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70582218",
  null
  
)

export default component.exports